import { Field } from "formik";
import React from "react";
import { FormikSelectComponent } from "../../../utilities/formUtils";

/**
 * CommonSelect is a component that renders a Formik select field with options
 * and with custom validation and computation.
 * 
 * @param {Object} props - props to pass to the component
 * @param {string} name - name of the field
 * @param {boolean} isTxn - whether the field has transaction type
 * @param {boolean} isLabel - whether the field has a label
 * @param {string} label - label of the field
 * @param {boolean} isSelection - whether the field is a select field
 * @param {boolean} focus - whether the field should be focused
 * @param {string} placeholder - placeholder of the field
 * @param {Function} validation - custom validation function
 * @param {Function} computeValue - custom computation function
 * @param {number} index - index of the field
 * @param {string} fieldName - name of the field
 * @param {string} fromField - name of the field to compute value from
 * @param {array} otherList - list of other fields to compute value from
 * @param {string} defaultTxnType - default transaction type
 * @param {Function} setDefaultFormType - function to set default form type
 * @param {string} classNameGet - class name to get
 * @param {boolean} isDisable - whether the field is disabled
 * @param {boolean} isClearable - whether the field is clearable
 * @param {number} width - width of the field
 * @param {array} options - options of the select field
 * @param {boolean} isMandatory - whether the field is mandatory
 * @param {boolean} upward - whether the field should be rendered upward
 * @param {Function} getValue - callback function to get value
 */
const CommonSelect = (
  {
    name,
    isTxn,
    isLabel,
    label,
    isSelection,
    focus,
    placeholder,
    validation,
    computeValue,
    index,
    fieldName,
    fromField,
    otherList,
    defaultTxnType,
    setDefaultFormType,
    classNameGet,
    isDisable,
    isClearable,
    width,
    options,
    isMandatory,
    upward,
    getValue: callback,
  },
  props
) => {

/**
 * Callback function to get the value of the select field
 * @param {string | number} value - value of the select field
 * @param {Function} setFieldValue - function to set the field value
 * @param {Object} values - object containing all the form values
 * @param {string} type - type of the form
 * @param {number} index - index of the form
 * @param {string} fieldName - name of the field
 */
  const getValue = (value, setFieldValue, values, type, index, fieldName) => {
    if (callback) {
      callback(value, setFieldValue, values, type, index, fieldName)
    }
  }

  return (
    <Field
      name={name}
      isLabel={isLabel}
      isTxn={isTxn}
      label={label}
      classNameGet={classNameGet}
      validation={validation}
      isSelection={isSelection}
      component={FormikSelectComponent}
      computeValue={computeValue}
      index={index}
      fieldName={fieldName}
      fromField={fromField}
      otherList={otherList}
      userProps={{ options, getValue, isDisable }}
      focus={focus}
      placeholder={placeholder}
      setDefaultFormType={setDefaultFormType}
      setFieldValueM={defaultTxnType}
      isClearable={isClearable}
      width={width}
      isMandatory={isMandatory}
      upward={upward}
    >
      {" "}
    </Field>
  );
};

export default CommonSelect;